// store.js
import Vue from 'vue';
import Vuex from 'vuex';
 
const cxState = { 
  ui: {
    markets: {
      items: [],
      firstLoad: true,
      menuCollapsed: false
    },
    retailers: {
      items: [],
      firstLoad: true,
      menuCollapsed: false
    }
  }
};

Vue.use(Vuex);
 
export default new Vuex.Store({
  namespaced: true,
  state: cxState,
  getters: {},
  mutations: {
    markets (state, value) {
      state.ui.markets.items = value;
      if (value.length > 0)
        state.ui.markets.firstLoad = false;
    },
    
    marketsMenuCollapsed (state, value) {
      state.ui.markets.menuCollapsed = value;
    },

    retailers (state, value) {
      state.ui.retailers.items = value;
      if (value.length > 0)
        state.ui.retailers.firstLoad = false;
    },

    retailersMenuCollapsed (state, value) {
      state.ui.retailers.menuCollapsed = value;
    }
  },
  actions: {}
});
 